import { ActivityResource } from "../../classes/Api/Activity";
import { reportApiError } from "../../utils";
export const deleteActivity = (activity) => {
    let promise;
    if (activity.series_ref && confirm('This activity is part of a series, do you want to delete the entire series?')) {
        promise = ActivityResource.destroySeries(activity.series_ref);
    }
    else {
        promise = ActivityResource.destroy(activity.id);
    }
    return promise.then((response) => {
        return response;
    }).catch((e) => {
        reportApiError(e);
    });
};
export default deleteActivity;
